import { render, staticRenderFns } from "./InformationUNNumber.vue?vue&type=template&id=9a23de4e&scoped=true"
import script from "./InformationUNNumber.vue?vue&type=script&lang=js"
export * from "./InformationUNNumber.vue?vue&type=script&lang=js"
import style0 from "./InformationUNNumber.vue?vue&type=style&index=0&id=9a23de4e&prod&scoped=true&lang=css"
import style1 from "./InformationUNNumber.vue?vue&type=style&index=1&id=9a23de4e&prod&lang=css"
import style2 from "./InformationUNNumber.vue?vue&type=style&index=2&id=9a23de4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a23de4e",
  null
  
)

export default component.exports